import { Color } from 'database'
import { colors } from 'bff'
import get from 'lodash.get'

export const getColorHex = (
  color: Color,
  level: '500' | '600' | '700' | '800' | '900' = '500'
): string => {
  switch (color) {
    case 'black':
      return colors.black

    default:
      return get(colors, `${color}.${level}`) || ''
  }
}
